/**
 * /blog — Blog index page
 * SEO: schema, meta, canonical
 */
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Box, Typography, Grid, Chip } from "@mui/material";
import BLOG_POSTS from "../data/blogPosts";

const BlogPage = () => {
  useEffect(() => {
    document.title = "Cam Girl Blog — Tips, Top Picks & Live Show Guides | InstaCamGirls";
    const setMeta = (name, content) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.name = name; document.head.appendChild(el); }
      el.content = content;
    };
    const setOg = (prop, content) => {
      let el = document.querySelector(`meta[property="${prop}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("property", prop); document.head.appendChild(el); }
      el.content = content;
    };
    setMeta("description", "Cam girl guides, top picks, and live show tips. Find the best Latina, MILF, ebony, and Asian cam performers — updated weekly.");
    setOg("og:title", "Cam Girl Blog | InstaCamGirls");
    setOg("og:description", "Guides, top picks, and tips for cam show fans. Updated weekly.");
    let canon = document.querySelector("link[rel='canonical']");
    if (!canon) { canon = document.createElement("link"); canon.rel = "canonical"; document.head.appendChild(canon); }
    canon.href = "https://instacamgirls.com/blog";
  }, []);

  return (
    <Box sx={{ maxWidth: 900, mx: "auto", px: 2, py: 4 }}>
      <Typography variant="h4" component="h1" sx={{ fontWeight: 700, mb: 1 }}>
        Cam Girl Blog
      </Typography>
      <Typography sx={{ color: "#666", mb: 4 }}>
        Guides, top picks, and tips for live cam fans. New posts weekly.
      </Typography>

      <Grid container spacing={3}>
        {BLOG_POSTS.map((post) => (
          <Grid item xs={12} sm={6} key={post.slug}>
            <Box
              component={Link}
              to={`/blog/${post.slug}`}
              sx={{
                display: "block",
                textDecoration: "none",
                border: "1px solid #eee",
                borderRadius: 2,
                p: 3,
                height: "100%",
                transition: "border-color 0.2s, box-shadow 0.2s",
                "&:hover": { borderColor: "#e91e63", boxShadow: "0 2px 12px rgba(233,30,99,0.1)" },
              }}
            >
              <Chip
                label={post.category}
                size="small"
                sx={{ mb: 1, backgroundColor: "#fce4ec", color: "#c2185b", fontWeight: 600, fontSize: 11 }}
              />
              <Typography variant="h6" sx={{ fontWeight: 700, color: "#111", mb: 1, lineHeight: 1.3 }}>
                {post.title}
              </Typography>
              <Typography sx={{ color: "#555", fontSize: 14, mb: 2, lineHeight: 1.6 }}>
                {post.metaDescription}
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Typography sx={{ fontSize: 12, color: "#999" }}>
                  {new Date(post.publishedAt).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}
                </Typography>
                <Typography sx={{ fontSize: 12, color: "#999" }}>
                  {post.readTime} min read
                </Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Internal links to popular categories */}
      <Box sx={{ mt: 6, p: 3, background: "#fafafa", borderRadius: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
          Browse Live Cam Girls
        </Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
          {[
            { label: "Latina Cam Girls", href: "/category/latina-cam-girls" },
            { label: "MILF Cam Girls", href: "/category/milf-cam-girls" },
            { label: "Ebony Cam Girls", href: "/category/ebony-cam-girls" },
            { label: "Asian Cam Girls", href: "/category/asian-cam-girls" },
            { label: "Teen Cam Girls 18+", href: "/category/teen-cam-girls" },
            { label: "BBW Cam Girls", href: "/category/bbw-cam-girls" },
            { label: "Mature Cam Girls", href: "/category/mature-cam-girls" },
            { label: "Amateur Cam Girls", href: "/category/amateur-cam-girls" },
          ].map(({ label, href }) => (
            <Chip
              key={href}
              label={label}
              component={Link}
              to={href}
              clickable
              sx={{ fontSize: 13 }}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default BlogPage;
